const DocumentsTab = ({ company }) => {

  return (
    <div className="space-y-1 text-sm p-6">
      <p p className="text-slate-400">Coming Soon!</p>
    </div>
  );
};

export default DocumentsTab;
